export class PaymentRequest
{
	name = "";
	accountNumber = "";
	expirationMonth = "";
	expirationYear = "";
	accountType = "";
// ReSharper disable once InconsistentNaming
	bankABACode = "";
	bankName = "";
	bankAccountType = "";
	paymentType = -1;
	verification = "";
	shoppingBasketId = "";
	websiteId = "";
	storeId = "";
	paymentMethodId = "";
	poNumber = "";
	transactionDate = new Date();
}


// WEBPACK FOOTER //
// ./src/models/PaymentRequest.ts